import { combineReducers } from 'redux'
import Reducer from './reducers';

const rootReducer = combineReducers({
    Reducer,
});

export default rootReducer;